<script setup>
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { MESSAGE_TYPES } from 'dashboard/components-next/message/constants.js';

import SearchResultMessageItem from 'dashboard/modules/search/components/SearchResultMessageItem.vue';
import MessageContent from 'dashboard/modules/search/components/MessageContent.vue';

defineProps({
  messages: { type: Array, required: true },
});

const { t } = useI18n();
const accountId = useMapGetter('getCurrentAccountId');

const isActivity = message => message.messageType === MESSAGE_TYPES.ACTIVITY;
const getAuthorName = message => message.sender?.name || t('SEARCH.BOT_LABEL');
</script>

<template>
  <ul class="space-y-3 list-none">
    <li v-for="message in messages" :key="message.id">
      <div v-if="isActivity(message)" class="flex justify-center py-1">
        <span class="text-xs text-n-slate-11 text-center px-3">
          {{ message.content }}
        </span>
      </div>
      <SearchResultMessageItem
        v-else
        :id="message.conversationId"
        :account-id="accountId"
        :inbox-id="message.inboxId"
        :created-at="message.createdAt"
        :message-id="message.id"
        :is-private="message.private"
        :attachments="message.attachments"
      >
        <MessageContent :author="getAuthorName(message)" :message="message" />
      </SearchResultMessageItem>
    </li>
  </ul>
</template>
